import {
  Biohazard, Boxes, Droplets, ShieldAlert,
  FlaskConical, PackageOpen, Wind,
} from "lucide-react";

export const SERVICES = [
  {
    id: "forensic",
    slug: "forensic-and-critical-remediation",
    title: "Forensic and Critical Remediation",
    desc: "Unattended death clean up, trauma and crime scene clean up, and biological/biohazard remediation involving controlled, standards based decontamination after an incident where bodily fluids or other potentially infectious materials may be present.",
    icon: Biohazard,
    span: "md:col-span-7",
    tag: "Core",
  },
  {
    id: "water",
    slug: "water-damage-restoration",
    title: "Water Damage Restoration",
    desc: "Assessment, extraction, drying and restoration of water-affected structures.",
    icon: Droplets,
    span: "md:col-span-5",
    tag: "Core",
  },
  {
    id: "mould",
    slug: "mould-remediation",
    title: "Mould Remediation",
    desc: "Assessment led remediation, including testing and inspection to understand the extent of microbial growth and the conditions contributing to it.",
    icon: Wind,
    span: "md:col-span-5",
    tag: "Core",
  },
  {
    id: "clandestine",
    slug: "clandestine-laboratory-cleanups",
    title: "Clandestine Laboratory Clean-ups",
    desc: "Remediation of meth affected properties and grow labs, delivered in alignment with the Australian Clandestine Drug Laboratory Remediation Guidelines.",
    icon: FlaskConical,
    span: "md:col-span-7",
    tag: "High-risk",
  },
  {
    id: "makesafe",
    slug: "property-make-safe",
    title: "Property Make Safe",
    desc: "Immediate stabilisation and securing of compromised properties following an incident.",
    icon: ShieldAlert,
    span: "md:col-span-4",
    tag: "Core",
  },
  {
    id: "stripout",
    slug: "strip-out-pack-out-clear-out",
    title: "Strip-out, Pack-out & Clear-out",
    desc: "Contents pack outs, property strip outs, and estate clear outs.",
    icon: PackageOpen,
    span: "md:col-span-4",
    tag: "Support",
  },
  {
    id: "hoarding",
    slug: "property-refresh-and-declutter",
    title: "Property Refresh and Declutter Service",
    desc: "Structured decluttering, clearance and sanitisation to refresh properties and restore safe, comfortable re-occupancy.",
    icon: Boxes,
    span: "md:col-span-4",
    tag: "Support",
  },
];

export const STANDARDS = [
  {
    code: "S540",
    title: "Trauma & Crime Scene Cleanup",
    desc: "Guiding principles for safe, respectful decontamination of scenes involving blood, bodily fluids and potential pathogens, supported by a controlled workflow and fully traceable process documentation.",
  },
  {
    code: "S520",
    title: "Mould Remediation",
    desc: "Containment, source removal and verification for microbial contamination — protecting occupant health and preventing recurrence.",
  },
  {
    code: "S500",
    title: "Water Damage Restoration",
    desc: "The framework for assessing category and class of water intrusion, then extracting, drying and restoring affected structures to a documented dry standard.",
  },
];

export const CLIENTS = [
  { label: "Local Councils", icon: "Landmark" },
  { label: "Support Services", icon: "HeartHandshake" },
  { label: "Real Estate Agencies", icon: "Building2" },
  { label: "Insurance Providers", icon: "ShieldCheck" },
  { label: "Residential & Commercial Clients", icon: "KeyRound" },
];

export const PROCESS = [
  { n: "01", t: "Assessment", d: "Attend site and assess the affected areas, hazards and risk." },
  { n: "02", t: "Scope", d: "Provide a clear, documented scope of works and quote." },
  { n: "03", t: "Remediation | Restoration", d: "Remediate and restore to the relevant IICRC standard for the works." },
  { n: "04", t: "Verification", d: "Verify the outcome with documented evidence and clearance." },
  { n: "05", t: "Safe Handover", d: "Return the property for safe re-occupancy with reporting." },
];


// Key towns/regions serviced within ~350km of Swan Hill (VIC, NSW & SA border)
export const AREAS = [
  // Victoria
  "Swan Hill", "Mildura", "Robinvale", "Nyah", "Nyah West", "Lake Boga",
  "Piangil", "Manangatang", "Sea Lake", "Ouyen", "Kerang", "Cohuna",
  "Pyramid Hill", "Boort", "Wedderburn", "Inglewood", "Charlton", "Donald",
  "Wycheproof", "Birchip", "Hopetoun", "Warracknabeal", "Horsham", "Dimboola",
  "Nhill", "Stawell", "Ararat", "St Arnaud", "Maryborough", "Castlemaine",
  "Bendigo", "Kyneton", "Heathcote", "Rochester", "Echuca", "Kyabram",
  "Shepparton", "Ballarat",
  // New South Wales
  "Wentworth", "Buronga", "Dareton", "Euston", "Balranald", "Hay", "Ivanhoe",
  "Hillston", "Griffith", "Leeton", "Narrandera", "Coleambally",
  "Darlington Point", "Jerilderie", "Deniliquin", "Barham", "Moama",
  "Finley", "Tocumwal", "Berrigan", "Corowa", "Mulwala", "West Wyalong",
  "Wagga Wagga",
  // South Australia (Riverland)
  "Renmark", "Paringa", "Berri", "Barmera", "Loxton", "Waikerie",
];
